'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MealPlanner$AddMealDialogData(date, mealType) {
  this.De = null;
  this.LM = null;
  this.De = date;
  this.LM = mealType;
}
export { $c_Lmealorama_components_MealPlanner$AddMealDialogData as $c_Lmealorama_components_MealPlanner$AddMealDialogData };
$p = $c_Lmealorama_components_MealPlanner$AddMealDialogData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MealPlanner$AddMealDialogData;
/** @constructor */
function $h_Lmealorama_components_MealPlanner$AddMealDialogData() {
}
export { $h_Lmealorama_components_MealPlanner$AddMealDialogData as $h_Lmealorama_components_MealPlanner$AddMealDialogData };
$h_Lmealorama_components_MealPlanner$AddMealDialogData.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 131411193, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_MealPlanner$AddMealDialogData)) {
    var x = this.De;
    var x$2 = x$0.De;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.LM;
      var x$4 = x$0.LM;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "AddMealDialogData";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.De;
  }
  if ((n === 1)) {
    return this.LM;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_components_MealPlanner$AddMealDialogData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ka)));
}
export { $isArrayOf_Lmealorama_components_MealPlanner$AddMealDialogData as $isArrayOf_Lmealorama_components_MealPlanner$AddMealDialogData };
var $d_Lmealorama_components_MealPlanner$AddMealDialogData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MealPlanner$AddMealDialogData, "mealorama.components.MealPlanner$AddMealDialogData", ({
  ka: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_MealPlanner$AddMealDialogData as $d_Lmealorama_components_MealPlanner$AddMealDialogData };
//# sourceMappingURL=mealorama.components.-Meal-Planner$-Add-Meal-Dialog-Data.js.map
